import {isUndefined, omitBy} from 'lodash-es';

import {
    convertPropertiesFormDataToRequestData,
} from 'components/report-configuration/tabs/report-properties-settings/utils';
import {convertArrayToMap, convertMapToArray} from 'modules/data/utils/data.utils';

import {IReportConfigurationDataDto} from '../report-configuration-dto';
import {TReportConfigurationConvertedMenuItem, TReportConfigurationDataConverted} from '../report-configuration-types';

export type TConvertConfigurationDataFromResponseArgs = {
    dataToConvert: Partial<IReportConfigurationDataDto>;
}

const convertReportMenu = <T=any>(
    reportMenu: any[] | undefined,
    convertFunction: Function,
) => {
    if (!reportMenu) return reportMenu;
    const convert: (
        menu: any[]) => T[] = menu => {
            const menuConverted = menu?.map(menuItem => {
                const reportColumns = menuItem.reportColumns
                    ? convertFunction(menuItem.reportColumns) : undefined;
                const {children} = menuItem;
                return {
                    ...menuItem,
                    reportColumns,
                    children: children ? convert(children) : undefined,
                };
            });
            return menuConverted as T[];
        };
    return convert(reportMenu);
};

export const convertConfigurationDataFromResponse = ({
    dataToConvert,
}: TConvertConfigurationDataFromResponseArgs) => {
    const {
        reportHeaders,
        reportColumns,
        reportMenu,
        reportGroups,
        queryParameters,
        ...restConfigurationParams
    } = dataToConvert;
    const configurationDataConverted = {
        ...restConfigurationParams,
        reportGroups: convertMapToArray(reportGroups),
        reportHeaders: convertMapToArray(reportHeaders),
        reportColumns: convertMapToArray(reportColumns),
        queryParameters: convertMapToArray(queryParameters),
        reportMenu: convertReportMenu<
            TReportConfigurationConvertedMenuItem>(reportMenu, convertMapToArray), // рекурсивная конвертация
    };
    const configurationDataNoUndefined = omitBy(configurationDataConverted, v => isUndefined(v));

    return configurationDataNoUndefined as TReportConfigurationDataConverted;
};

export type TConvertConfigurationDataForRequest = {
    convertedData: Partial<TReportConfigurationDataConverted>;
}

export const convertConfigurationDataForRequest = ({
    convertedData,
}: TConvertConfigurationDataForRequest) => {
    const {
        reportHeaders,
        reportColumns,
        reportMenu,
        reportGroups,
        queryParameters,
        ...restConfigurationParams
    } = convertedData;

    const configurationDataConverted = {
        ...restConfigurationParams,
        reportGroups: convertArrayToMap(reportGroups),
        reportHeaders: convertArrayToMap(reportHeaders),
        reportColumns: convertArrayToMap(reportColumns),
        queryParameters: convertPropertiesFormDataToRequestData(queryParameters),
        reportMenu: convertReportMenu<any>(reportMenu, convertArrayToMap),
    };

    const configurationDataNoUndefined = omitBy(configurationDataConverted, v => isUndefined(v));
    return configurationDataNoUndefined as Partial<IReportConfigurationDataDto>;
};
